import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from 'studio-components/icon/types';

@Component({
  selector: 'studio-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss'],
})
export class SidebarItemComponent {
  @Input() icon: IconName;
  @Output() public buttonClicked = new EventEmitter<void>();

  clicked() {
    this.buttonClicked.emit();
  }
}
